import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation DeleteAccessory($companyId: ID!, $id: ID!) {
    deleteAccessory(companyId: $companyId, id: $id) {
      accessory {
        id
      }
      errors {
        path
        message
      }
    }
  }
`
